<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.752 20.482"
    aria-hidden="true"
  >
    <g
      id="Group_3106"
      data-name="Group 3106"
      transform="translate(-1175 -1077.471)"
    >
      <g
        id="Path_531"
        data-name="Path 531"
        transform="translate(1175 1077.471)"
        fill="none"
      >
        <path
          d="M7.876,0a7.876,7.876,0,0,1,7.876,7.876c0,4.35-7.876,12.606-7.876,12.606S0,12.226,0,7.876A7.876,7.876,0,0,1,7.876,0Z"
          stroke="none"
        />
        <path
          d="M 7.875961303710938 2 C 4.635941505432129 2 2.000000953674316 4.635940551757812 2.000000953674316 7.875961303710938 C 2.000000953674316 8.489570617675781 2.342231750488281 10.37077140808105 5.512141227722168 14.57609081268311 C 6.350006103515625 15.68763160705566 7.195352554321289 16.70458984375 7.87619161605835 17.49163055419922 C 8.54990291595459 16.71280288696289 9.385232925415039 15.70794677734375 10.2177906036377 14.60524082183838 C 11.29804134368896 13.17446136474609 12.15210151672363 11.87411117553711 12.7562313079834 10.74029064178467 C 13.62256145477295 9.114380836486816 13.75192165374756 8.247800827026367 13.75192165374756 7.875961303710938 C 13.75192165374756 4.635940551757812 11.11598110198975 2 7.875961303710938 2 M 7.875961303710938 0 C 12.22573089599609 0 15.75192165374756 3.526191711425781 15.75192165374756 7.875961303710938 C 15.75192165374756 12.22573089599609 7.875961303710938 20.482421875 7.875961303710938 20.482421875 C 7.875961303710938 20.482421875 9.5367431640625e-07 12.22573089599609 9.5367431640625e-07 7.875961303710938 C 9.5367431640625e-07 3.526191711425781 3.526191711425781 0 7.875961303710938 0 Z"
          stroke="none"
          fill="currentColor"
        />
      </g>
      <g
        id="Ellipse_37"
        data-name="Ellipse 37"
        transform="translate(1179.999 1082.471)"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      >
        <circle cx="3" cy="3" r="3" stroke="none" />
        <circle cx="3" cy="3" r="2" fill="none" />
      </g>
    </g>
  </svg>
</template>
